<ng-container *ngIf="viewModel$ | async as vm">
  <div class="add-inventory">
    <quill-editor
      [ngModel]="vm.inventoryText"
      (ngModelChange)="
        store.dispatch(
          actions.addInventoryContentsChanged({ inventoryText: $event })
        )
      "
      format="object"
      [modules]="modules"
    ></quill-editor>
    <div class="buttons">
      <p-button
        [label]="vm.buttonLabel"
        [icon]="vm.buttonIcon"
        [disabled]="vm.buttonDisabled"
        (onClick)="store.dispatch(actions.addInventoryButtonClicked())"
      ></p-button>
    </div>
  </div>
</ng-container>
